module.exports = __webpack_public_path__ + "img/digitalis-gazdasagi-jog.301a6b06.png";